import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpRequestService } from './http-request.service';
import { finalize, tap } from 'rxjs';

export const httpRequestInterceptor: HttpInterceptorFn = (req, next) => {
  const httpRequest = inject(HttpRequestService);

  return next(req).pipe(
    tap(() => {
      if (!httpRequest.running) {
        httpRequest.start();
      }
    }),
    finalize(() => httpRequest.running && httpRequest.complete())
  );
};
